import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { SpecialPeriodModel } from './specialperiod.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';


@Injectable()
export class SpecialPeriodService {
  constructor(private authService: AuthService, private http: Http) { }

	public GetSpecialPeriodList(input?: DataListModel): Observable<IAPIResponse> {
		let getSpecialPeriodUrl = WeGoConfig.API_GET_SPECIALPERIOD_LIST;
		let queryString = this.authService.HandleAPIListInput(input);
		if (queryString) {
			getSpecialPeriodUrl = getSpecialPeriodUrl + "?" + queryString;
		}
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getSpecialPeriodUrl, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}
  public UpdateSpecialPeriod(specialperiod: SpecialPeriodModel): Observable<IAPIResponse> {
    let body = specialperiod;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_SPECIAL_PERIOD_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSpecialPerionByHashId(specialPeriondHashId: string): Observable<IAPIResponse> {
		let getTimeBlockUrl = WeGoConfig.API_GET_SPECIAL_PERIOD_BY_HASH + "?specialPeriondHashId=" + specialPeriondHashId;
		let headers = this.authService.GetHeader();
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getTimeBlockUrl, options)
			.map(this.authService.HandleAPIResponse)
			.catch(this.authService.HandleAPIError);
	}
	public ExportSpecialPeriodList(input?: DataListModel): any {
		input.currentPage=0;
		let queryString = this.authService.HandleAPIListInput(input);
		let getAttributeListUrl = WeGoConfig.API_EXPORT_SPECIAL_PERIOD_LIST + "?" + queryString;
		let headers = this.authService.GetHeader('text/csv');
		let options = new RequestOptions({ headers: headers });
		return this.http.get(getAttributeListUrl, options);
	}
 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/specialperiod/models/specialperiod.service.ts